// Convert data to dropdown options
export const mapSelectOptions = <T extends Record<string, any>>(
  items: T[] | undefined,
  labelKey: keyof T,
  valueKey: keyof T,
) => items?.map((item) => ({ label: item[labelKey] as string, value: item[valueKey] as string }))
